var React = require('react');

function FbIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28.9549 1.99915H4.04611C3.63624 1.99931 3.2432 2.16221 2.95337 2.45203C2.66355 2.74186 2.50065 3.1349 2.50049 3.54477V28.4535C2.50065 28.8634 2.66355 29.2564 2.95337 29.5463C3.2432 29.8361 3.63624 29.999 4.04611 29.9991H16.5005V18.9991H13.1536V14.9991H16.5005V11.8116C16.5005 8.19539 19.0086 6.22664 22.2392 6.22664C23.7849 6.22664 25.4474 6.34289 25.8336 6.39414V10.171H23.2599C21.5024 10.171 21.1674 11.0023 21.1674 12.2273V14.9991H25.3549L24.808 18.9991H21.1674V29.9991H28.9549C29.3647 29.999 29.7578 29.8361 30.0476 29.5463C30.3374 29.2564 30.5003 28.8634 30.5005 28.4535V3.54477C30.5003 3.1349 30.3374 2.74186 30.0476 2.45203C29.7578 2.16221 29.3647 1.99931 28.9549 1.99915Z","fill":"white"}));
}

FbIcon.defaultProps = {"width":"33","height":"32","viewBox":"0 0 33 32","fill":"none"};

module.exports = FbIcon;

FbIcon.default = FbIcon;
